var _rect, _rect2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgDisabled = function SvgDisabled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 14 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    rx: 6.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    x: 0.5,
    y: 0.5,
    stroke: "#E95F6A",
    rx: 6.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M7 4.375c-.237 0-.472.026-.702.08a.375.375 0 0 1-.171-.73c.286-.067.58-.1.873-.1V4v-.375c1.463 0 2.586.835 3.32 1.619A7.755 7.755 0 0 1 11.44 6.79l.015.029.004.008.002.003-.335.169-.33-.177c-.032.06-.065.118-.098.176a7.004 7.004 0 0 0-.923-1.243C9.101 5.04 8.162 4.375 7 4.375Zm3.697 2.624a6.56 6.56 0 0 1-.669.956.375.375 0 1 0 .574.483 7.31 7.31 0 0 0 .854-1.261.375.375 0 0 0 .004-.345L11.125 7l-.335.168-.003-.005a3.938 3.938 0 0 0-.09-.164ZM4.545 4.474c.15-.114.36-.1.493.033l1.43 1.431.003.003L8.06 7.529l.003.002 1.43 1.431a.375.375 0 0 1-.037.564 4.151 4.151 0 0 1-2.449.849H7c-1.462 0-2.586-.835-3.32-1.619A7.752 7.752 0 0 1 2.546 7.18l-.004-.008-.002-.003L2.875 7l-.335.168a.375.375 0 0 1 .005-.345 7.294 7.294 0 0 1 2-2.349ZM3.303 7.001a7.003 7.003 0 0 0 .923 1.242c.672.716 1.61 1.38 2.77 1.382A3.401 3.401 0 0 0 8.64 9.17l-.87-.871A1.5 1.5 0 0 1 5.7 6.231l-.956-.955A6.544 6.544 0 0 0 3.303 7Zm2.957-.21a.75.75 0 0 0 .95.949l-.95-.95Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E95F6A",
    fillRule: "evenodd",
    d: "M2.232 2.05a.5.5 0 0 1 .707 0l9 9a.5.5 0 1 1-.707.708l-9-9a.5.5 0 0 1 0-.707Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDisabled);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;